const jp = {
  email: "メール",
  birth: "生年月日",
  gender: "性別",
  last_name: "姓",
  first_name: "名",
  postal_code: "郵便番号",
  province: "都道府県",
  city: "市区町村",
  address1: "住所",
  address2: "建物名、部屋番号など (任意)",
  phone_number: "電話番号",
  search_address: "郵便番号検索",
  save: "保存",
  cancel: "キャンセル",
  edit: "編集",
  delete: "削除",
  subtotal: "小計",
  shipping_fee: "送料",
  discount: "割引",
  total_amount: "お支払い金額",
  refunded_amount: "返金額",
  cancel_order: "注文キャンセル",
  request_return: "返品申請",
  tracking_number: "追跡番号",
  payment_method: "お支払い方法",
  male: "男性",
  female: "女性",
  "non-binary": "ノンバイナリー",
  current_password: "現在のパスワード",
  new_password: "新しいパスワード",
  confirm_new_password: "パスワード確認",
  view_detail: "詳細を見る",
  confirm: "確認",
  submit: "送信",
  deactivate: "退会",
  password: "パスワード",
  notification: "通知",
  gift: "ノベルティ",
  change: "変更",
  popup_close: "今日一日表示しない",
  return_shipping: "返品送料",
  cancel_order_description: "注文をキャンセルしますか？<br/>決済された金額は営業日から最大3〜5日以内に払い戻されます。",
  password_reset_email: "パスワード再設定メールが送信されました。",
  password_reset_social_email: "ソーシャルログインアカウントはパスワードの再設定が不可能です。",
  newsletter_subscribe_message: "メール認証を完了するとニュースレターを購読できます。",
  copy_url: "商品のURLがコピーされました。",
  copy_url_message: "貼り付けて商品のURLを共有してください。",
  modify_account_info: "会員情報の修正が完了しました。",
  payment: "決済が正常に処理されました。",
  newsletter_subscribe: "ニュースレター購読確認メールが送信されました。",
  restock: "再入荷通知の登録が完了しました。",
  wishlist_add: "ウィッシュリストへの追加が完了しました。",
  wishlist_remove: "ウィッシュリストからの削除が完了しました。",
  address_remove: "住所の削除が完了しました。",
  cancel_order_success: "注文のキャンセルが完了しました。",
  validate_toss: "Toss社員の確認が完了しました。",
  adult_verification: "年齢確認が完了しました。",
  password_change: "パスワードが変更されました。 再度ログインしてください。",
  copy: "テキストがクリップボードにコピーされました。",
  phone: "正しい電話番号の形式で入力してください。",
  phone_taken: "すでに登録されている電話番号です。",
  payment_cancel: "進行中の決済がキャンセルされました。決済を完了するには再度お試しください。",
  quantity_insufficient: "注文しようとしている商品の数量が、注文過程で購入可能数量を超えました。カート内の該当商品の数量が購入可能数量に合わせて調整され、品切れの商品は削除されます。",
  necessary_shipping_address: "商品を受け取る配送先を入力してください。",
  necessary_invalid_shipping_address: "入力された配送先住所が正しくありません。配送先住所が正しいか確認してください。",
  necessary_payment_method: "決済手段を選択してください。",
  no_return_for_gift: "サ恩品のみの返品はできません。",
  no_returnable_product: "注文履歴に現在返品不可能な商品があります。該当商品はカスタマーセンターにお問い合わせください。",
  no_quantity_product: "返品申請できない商品です。",
  same_account_info: "既存の顧客情報と異なる値を入力してください。",
  invalid_cart: "購入可能な商品がありません。",
  reusable_bag_limit: "Reusable Carrier Bagは単独で購入できません。",
  fail_calculate_order: "注文金額の計算に失敗しました。もう一度お試しください。",
  already_restock: "すでに再入荷通知が申請されている電話番号です。",
  gifting_necessary_receiver_name: "受取人のお名前を入力してください。",
  gifting_necessary_sender_phone: "お客様情報ページ（<a>{{storeDomain}}/account</a>）で電話番号を保存してから、もう一度お試しください。",
  gifting_necessary_message_content: "ギフトメッセージを入力してください。",
  no_login: "ログインが必要です。",
  remove_product: "返品申請個数は1個以上である必要があります。",
  over_product: "返品可能な最大個数まで選択されました。",
  no_image: "返品理由に関連する写真をアップロードしてください。",
  no_email: "登録されていないメールアドレスです。",
  exceed_purchase_limit: "累計注文金額とカート金額の合計が注文金額上限を超えました。カートの商品および金額を調整してください。",
  remaining_limit: "最大注文可能金額: ₩{{amount}}",
  adult_only: "*成人のみ",
  separate_required: "カートに年齢確認が必要な商品が含まれています。<br/>この商品は通常商品と一緒にお支払いいただけないため、通常商品とは分けてご注文ください。",
  request_identity_verification: "カートに年齢確認が必要な商品が含まれています。<br/>本人確認のうえ、ご注文にお進みください。",
  need_identity_verification: "本人確認がキャンセルされました。商品をご購入いただくには、もう一度お試しください。",
  fail_identity_verification: "本人確認に失敗しました。もう一度お試しください。",
  empty_cart: "カートに商品がないため、前のページに戻ります。",
  necessary_billing_address: "請求先住所を入力してください。",
  no_quantity_cart: "こちらの商品は在庫切れのため、カートに追加できません。",
  already_feedback: "すでにアンケートにご回答いただいております。",
  already_used_discount_code: "すでに使用された割引コードです。",
  failed_api_discount_code: "割引コードの使用に失敗しました。しばらくしてからもう一度お試しください。",
  url_not_found: "存在しないURLです。",
  necessary_country: "国を入力してください。",
  necessary_lastName: "姓を入力してください。",
  necessary_firstName: "名を入力してください。",
  necessary_city: "都市を入力してください。",
  necessary_zip: "郵便番号を入力してください。",
  necessary_province: "都道府県を入力してください。",
  necessary_address1: "住所を入力してください。",
  necessary_address2: "住所（詳細）を入力してください。",
  necessary_phone: "電話番号を入力してください。",
  necessary_english: "英語、数字、特殊文字のみで入力してください。",
  invalid_phone: "電話番号を正確に入力してください。",
  invalid_birthday: "生年月日を形式に合わせて入力してください (例: MM/DD/YYYY)。",
  necessary_password: "パスワードを入力してください。",
  necessary_new_password: "変更するパスワードを入力してください。",
  necessary_confirm_password: "変更するパスワードをもう一度入力してください。",
  necessary_email: "メールアドレスを入力してください。",
  match_password: "パスワードが一致しません。再度ご確認ください。",
  necessary_consent: "個人情報の収集および利用に同意してください。",
  failed_no_return_product: "返品可能な商品がありません。",
  already_delete_account: "すでに退会処理中のアカウントです。",
  verification_error_description: "本人確認の処理中にエラーが発生しました。",
  verification_error_failure: "認証に失敗しました。もう一度お試しください。",
  verification_none: "認証されていないアカウントです。<br/>初回に1度、本人確認を行ってください。",
  raffle_already_entered: "すでに応募済みの商品です。",
  raffle_error: "応募の処理中にエラーが発生しました。",
  gifting_fetch_failed: "ギフト情報の読み込み中にエラーが発生しました。",
  gifting_accept_failed: "ギフトの受け取り処理中にエラーが発生しました。もう一度お試しください。",
  gifting_share_data: "ギフト送信に必要なデータの読み込み中にエラーが発生しました。もう一度お試しください。",
  select_option: "オプションを選択してください。",
  cancel_order_failed: "注文のキャンセルが処理されませんでした. しばらくしてからもう一度お試しください。",
  checkout_failed: "決済ページでエラーが発生しました。しばらくしてからもう一度お試しください。",
  invalid_english: "英字で入力してください。",
  invalid_japanese: "日本語で入力してください。",
  invalid_zip: "郵便番号を正確に入力してください。",
  necessary_field: "必須入力項目です。",
  toss_payment: "決済サービスでエラーが発生しました。もう一度お試しください。",
  no_detail_reason: "返品の詳細理由を入力してください。",
  server: "サーバーでエラーが発生しました。しばらくしてからもう一度お試しください。",
  login_success: "ログインしました。",
  logout: "ログアウトしました。",
  register_complete: "会員登録が完了しました。",
  login_failed: "メールアドレスまたはパスワードが正しくありません。",
  end_session: "セッションが満了しました。再度ログインしてください。",
  social_account: "{{social}}で登録したアカウントです。{{social}}ログインを利用してください。",
  not_match_password: "現在使用中のパスワードを正確に入力してください。",
  same_password: "現在のパスワードと異なるパスワードを入力してください。",
  verification: "本人確認が完了しました。",
  raffle_entry: "応募が完了しました。",
  quantity_limit: "購入可能な数量を超えました。",
  necessary_payment_data: "決済情報がありません。もう一度お試しください。",
  payment_failed: "決済が正常に完了しませんでした。もう一度お試しください。",
  blocked_address: "選択された住所は利用規約により配送できない住所です。\n別の住所をご利用ください。",
  order_status: {
    title: "注文状況",
    refunded: "払い戻し完了",
    canceled: "キャンセル済み",
    partially: "部分払い戻し済み",
    completed: "決済完了",
    return: "返品受付済み",
    return_approved: "返品承認済み",
    shipped: "配送完了",
    partially_shipped: "一部配送完了",
    scheduled: "予約配送前",
    scheduled_shipped: "予約配送準備中",
    completed_shipped: "予約配送完了",
    preparing: "配送準備中",
    paid: "決済完了",
    pending: "決済確認中",
    prizeCancel: "当選キャンセル",
    drawCancel: "応募キャンセル",
    drawLose: "落選",
    drawWin: "当選",
    drawApply: "応募完了",
    gifting_pending: "ギフト受け取り待ち",
    gifting_accepted: "ギフト受け取り完了",
    preorder: "予約発送",
  },
  account: {
    order_history: "注文履歴",
    draw_history: "応募履歴",
    event_history: "イベント参加履歴",
    shipping_address: "お届け先の管理",
    log_out: "ログアウト",
    new_collection: "新商品を見る",
    return_history: "返品履歴",
    personal_information: {
      description:
        "以下のページで会員情報の確認・編集が可能です。<br />注文および配送に関するお問い合わせは、メールまたは右下のチャットサービスからお問い合わせください。",
      accepts_marketing: "マーケティング情報の受信および個人情報の活用同意（選択）",
      update_information: "情報修正",
      employee: "アカウントです。（30% - 50% 常時割引特典）",
    },
    reset_password: {
      description: "パスワードを再設定するためのメールを送信します。",
      request: "パスワード変更",
    },
    deactivation: {
      request: "アカウント削除の申請が受け付けられると、会員情報はすべて削除され、ストアのサービスをご利用いただけなくなります。",
      ask: "本当に退会しますか？<br />「確認」ボタンを押すと会員退会を進行します。",
      processing: "会員退会処理中",
    },
    social_login: {
      change_password: "現在連携されているソーシャルログインサービスです。",
    },
    membership: {
      discount: "Benefit: {{amount}}",
      coupon: "Discount Code: 月間コード {{amount}}%",
      current: "現在のメンバーシップランク",
      next: "{{month}}月 予定メンバーシップランク",
      my_membership: "メンバーシップ ランク",
      more_info: "メンバーシップ特典の詳細を見る",
      accumulated_amount1: "過去1年間のご購入累計額は",
      accumulated_amount2: " {{amount}}円です。",
      next_level_new1: "{{next_level}} ランクまで",
      next_level_new2: " あと{{amount}}円です。",
      employee_discount: "社員割引率を適用",
      benefit: {
        title: "{{membership}} 割引特典",
        discount: "{{discount}} 常時割引",
        code: "{{code}} 割引コード 月1回支給",
      },
      amount: {
        current: "現在の累積金額は {{amount}} です。",
        next: "{{membership}} ランクまで残り {{amount}} です。",
      },
      member: {
        discount_code: "",
        benefits: "常時1%割引",
        purchase_amount: "￥0 以上 -\n￥300,000 未満",
      },
      silver: {
        benefits: "常時3%割引\n月間5%割引コード支給",
        purchase_amount: "￥300,000 以上 -\n￥2,000,000 未満",
      },
      gold: {
        benefits: "常時5%割引\n月間7%割引コード支給",
        purchase_amount: "￥2,000,000 以上 -\n￥5,000,000 未満",
      },
      platinum: {
        benefits: "常時7%割引\n月間10%割引コード支給",
        purchase_amount: "￥5,000,000 以上 -\n￥10,000,000 未満",
      },
      vip: {
        benefits: "常時10%割引\n月間15%割引コード支給",
        purchase_amount: "￥10,000,000 以上",
      },
      employee: {
        discount_code: "",
        benefits: "30% - 70% 常時割引",
      },
      policy: {
        "1": "今後のメンバーシップ特典および選定基準は、予告なく変更される場合があります。",
        "2": "会員ランク特典は {{storeName}} オンラインストアでのみ適用可能です。",
        "3": "ランク別割引コード特典として、毎月1日午前11時に1回使用可能なメンバーシップ専用割引コードが発行され、翌月1日午前10時59分まで使用可能です。（マーケティング情報受信の可否およびマーケティングのための個人情報収集・利用を拒否された場合、各種お知らせや特典に制限がある場合があります。）",
        "4": "ランク基準は毎月1日午前11時から順次変更され、変更日から直近3年以内の累積実決済金額を基準に適用されます。",
        "5": "メンバーシップ会員ランクは、総注文金額からキャンセルおよび返金を差し引いた実決済金額を基準に算定されます。",
        "6": "実決済金額は割引適用後、送料を除いた純粋な商品金額であり、注文日から7日経過後に加算されます。",
        "7": "割引コードをご使用の場合、1回の注文につき1つのコードのみ使用可能で、他の割引コードとの重複使用はできません。",
        "8": "一部の商品については割引および特典の対象外となります。",
        "9": "会員ランクによる特典は他人に譲渡できません。（不正な方法により累積された実績と疑われる場合、会員ランクが降格されることがあります。）",
        "10": "一部の割引コードはメンバーシップ常時割引との重複適用ができない場合があります。",
        "11": "発行されたコードは使用と同時に消滅し、再発行および復元はできません。",
      },
    },
    order: {
      none: "注文履歴がありません。",
      already: "すでに応募済みです。",
    },
    info: {
      me: "マイ情報",
      agree: "以下の情報とあわせてマーケティング情報の受信・活用に同意いただくと、さまざまな会員特典をご利用いただけます。",
      card: "保存されたカード",
      card_save: "よく使うカードをアカウントに保存して管理し、より便利に決済してください。",
      password_info: "個人情報保護のため、1年以上パスワードを変更していない場合はパスワードの変更をお勧めしています。",
      social: "ソーシャルログイン",
      delete_ask: "本当に退会しますか？\n「Okay」ボタンを押すと退会手続きを行います。",
      marketing_agree: "マーケティング情報の受信",
      save_card: "保存されたカードの管理",
      male: "男性",
      female: "女性",
    },
    return: {
      select_item: "返品を申請する商品を選択してください。",
      return_reason: "返品理由",
    },
    forgot_password: {
      description: "パスワードをお忘れですか？こちらから再設定してください。",
      label: "パスワードをお忘れの方",
    },
    create_account: {
      description: "利用規約およびプライバシーポリシーに同意します。",
      label: "アカウント作成",
    },
  },
  order_history: {
    description: "注文履歴を一目で確認してください。<br/>注文をクリックすると、配送先や決済情報などの詳細情報を確認できます。",
  },
  wishlist: {
    description: "お気に入りの商品をウィッシュリストに保存してください。<br/>欲しいアイテムを1か所にまとめて、いつでも確認できます。",
    empty: "ウィッシュリストに保存された商品がありません。",
    delete_ask: "この商品をウィッシュリストから削除しますか？",
  },
  address_book: {
    create_new_address: "新しい住所を追加",
    edit_address: "配送先の修正",
    set_as_default_address: "デフォルトの配送先に設定",
    description: "よく使う配送先を保存して管理してください。<br/>デフォルトの配送先を設定すると、より迅速かつ便利に注文できます。",
    delete_address: "配送先を本当に削除しますか？",
    save: "住所保存",
    save_continue: "住所選択",
    change: "住所変更",
    use_other: "お届け先を変更する",
    default_address: "デフォルトのお届け先",
    in_use: "使用中",
    my_addresses: "お届け先一覧",
    empty: "保存されたお届け先はまだありません。",
    change_address: "別のお届け先を使用する",
    empty_address: "保存されたお届け先がありません。",
  },
  contact: {
    description:
      "ストア利用中にお問い合わせがある場合は、以下の方法でご連絡ください。<br/>注文の変更・キャンセル、配送追跡は次のページで可能です。",
    working_hours: "カスタマーセンター営業時間: 平日 午前9時 - 午後5時",
    other_inquries: "その他のお問い合わせは <email>{{supportEmail}}</email> をご利用ください。",
    cs_info: "※ お電話でのご相談は承っておりません。チャットサポートまたはメールでお問い合わせください。",
    order_history: "注文履歴を見る",
    membership: "過去12ヶ月間のランクポイントに基づいて、毎月1日に新しい会員ランクが決定されます。さまざまな特典をぜひご確認ください。",
    my_membership: "マイランクを確認する",
  },
  checkout: {
    notice: "システム上の問題により、関税および税金が初回のお支払いとは別に請求される場合があります。ご不便をおかけし申し訳ございません。",
    create_shipping_address: "配送先住所を登録して注文を進めてください。",
    description:
      "すべての取引は安全に暗号化されます。<br/>決済情報を保存して、迅速かつ便利に注文してください。一般決済は他の決済手段を選択して利用できます。",
    use_as_billing_address: "請求先住所として使用",
    pay_now: "決済",
    consent: "注文内容をすべて確認し、ストアおよび決済代行サービス（Toss Payments）の利用規約に同意します。",
    discount_code_alert: "* コラボレーションおよび一部のコレクションは割引コード適用の対象外です。",
    discount_code_alert_description:
      "一部のコレクションは割引から除外され、割引コードが適用された注文をキャンセルした場合、割引コードは再発行されません。",
    wrong_customer_id: "顧客情報が一致しません。現在ログインしているアカウントをログアウト後、同じアカウントで再度ログインしてください。",
    wrong_cart_amount: "カートの金額が決済金額と一致しません。",
    wrong_discount_name: "有効ではない割引コードです。",
    wrong_discount_code: "有効ではない割引コードが適用されました。もう一度お試しください。",
    wrong_cart_changed: "商品、数量、または価格が変更されたためカートが更新されました。もう一度お試しください。",
    gifting_description: "大切な方へギフトを贈りましょう。<br/>お支払いが完了すると、LINEでギフトメッセージを送信できます。",
    gifting_card_message: "ギフトメッセージに含める内容をご記入ください。",
    gifting_recipient: "受け取られる方がご自身宛のギフトだとわかるよう、受取人のお名前はできるだけ本名でご入力ください。",
    discount_code_placeholder: "割引コードを入力してください。",
  },
  cart: {
    empty: "カートに入っている商品がありません。",
    discount: "配送料および割引コードは決済段階で適用されます。",
    checkout: "購入する",
    preorder: "予約発送商品は通常の商品と一緒にカートに入れることはできず、現在のカートで単独で購入する必要があります。",
  },
  order_completed: {
    description:
      "ご注文が正常に処理されました。<br/>注文情報は注文履歴ページでご確認いただけます。商品の発送時に通知およびメールでご案内いたします。",
  },
  product: {
    restock_notification: {
      description: "メールアドレスをご登録ください。再入荷時にお知らせします。",
    },
    membership_auto_discount_notice: "メンバーシップ ランク割引の対象外商品です。",
    discount_code_unavailable_notice: "メンバーシップ割引コードをご利用いただけない商品です。",
    pigment_warning: "色落ちや色移りの恐れがありますので、洗濯および着用時にご注意ください。",
    preorder_description:
      "予約発送商品は通常商品と配送スケジュールが異なるため、既存のカートとは別に、この画面から単独でのご購入のみ可能です。",
    pre_order_warning:
      "プレオーダー商品は単独でのみご注文いただけます。<br/>この商品をカートに追加すると、カート内の通常商品は削除されます。",
    normal_items_warning:
      "プレオーダー商品は単独でのみご注文いただけます。<br/>この商品をカートに追加すると、カート内のプレオーダー商品は削除されます。",
    shipping: {
      description:
        "配送方法：宅配（一般配送）<br/>地域：全国地域<br/>期間：営業日2日〜5日<br/>案内：離島・山間部は追加料金が発生する場合があります。<br/><br/>不良・誤配送、広告内容と異なる配送の場合は、3ヶ月以内に受付してください。<br/>配送および返品の詳細については、以下のリンクのページでご確認ください。<information>{{domain}}</information>",
    },
  },
  collection: {
    empty: "申し訳ございません。現在このページに用意された商品がありません。",
    ready: "コレクションの商品を準備中です。",
  },
  return: {
    reason: "理由",
    request: "返品申請",
    request_description: "商品の状態により払い戻し予定金額が変更される場合や、返品申請が拒否される場合があります。",
    detail_reason: "詳細理由",
    description: "返品を申請する商品と理由を選択してください。<br/>返品申請は注文作成後7日以内のみ可能です。",
    requested_description: "返品申請が完了しました。<br/>返品の承認または拒否時にメールでご案内します。",
    view_policy: "配送・返品規約を見る",
    detail_description: "関連する説明を入力してください。",
    additional_description:
      "返品申請する商品と理由をもう一度確認してください。<br/>返品申請の内容が規定に反する場合、申請が拒否されることがあります。",
    add_image: "関連する写真をアップロードしてください。",
    select_reason: "返品理由を選択してください。",
    unwanted_notice: "自己都合による返品の場合、配送料が課金されることがあります。",
    refund_shipping_notice: "{{reason}}による返品の場合、送料が発生することがあります。",
    disabled_product: "*該当商品の返品についてはチャネルトークからお問い合わせください。",
    upload_image: "写真をアップロードしてください...",
    gift_description: "ノベルティは支給条件に応じて自動的に選択されます。",
    optional: "任意",
  },
  return_requested: {
    estimated_period: "最大7日",
    additional_charge: "*返品する商品のご購入価格が返品送料を下回る場合、追加の返品送料をご負担いただきます。",
    title: "返品を受け付けました。",
    estimated_refund_amount: "返金予定額",
    return_deadline: "返品期限",
  },
  search: {
    empty: "「{{value}}」に対する検索結果がありません。他の検索語でお試しください。",
    view_all: "すべて見る",
    alert: "検索語を入力してください。",
    no_matches: "検索条件に一致する商品はありません。",
  },
  membership: {
    title: "{{storeName}} メンバーシップで、特別割引に加え新商品やイベントの情報をいち早くお受け取りください。",
    higher: "{{currency}}{{amount}} 以上",
    lower: "{{currency}}{{amount}} 未満",
    discount: "常時割引 {{amount}}%",
    discount_rate: "常時割引率",
    coupon: "月間コード {{amount}}%",
    total_spent: "累計ご購入金額",
    left: "次のランクまであと ₩{{amount}} です。",
    total: "現在の累計ご購入金額は ₩{{amount}} です。",
    view_membership: "マイメンバーシップ情報を見る",
    description_text: "ランクに応じた常時割引に加え、メンバーシップ会員限定の各種割引やエクスクルーシブコンテンツをお楽しみください。",
    current_membership: "{{last_name}}{{first_name}}様のランクは <membership>{{membership}}</membership> です。",
    monthly_discount_code: "月間割引コード",
    description: {
      "1": "会員ランクの特典は {{storeName}} オンラインストアでのみご利用いただけます。",
      "2": "ランクは毎月1日に変更月から1年以内の累積金額を基準に適用されます。",
      "3": "累積金額は実決済額を基準とします。ただし、累積決済額は注文規定により、注文日から7日後から合算されます。",
      "4": "一部の商品については割引および特典の対象外となります。",
      "5": "発行されたコードは使用と同時に消滅し、再発行および復元はできません。",
      "9": "一部の商品については割引および特典の対象外となります。",
      "11": "発行されたコードは使用と同時に消滅し、再発行および復元はできません。",
    },
    policy: {
      "2": "会員ランクの特典は {{storeName}} オンラインストアでのみご利用いただけます。",
      "3": "ランク別の割引コード特典として、毎月1日午前11時に1回のみ使用できるメンバーシップ専用割引コードが発行され、翌月1日午前10時59分までご利用いただけます。（マーケティング情報の受信、およびマーケティング目的の個人情報の収集・利用に同意されない場合、各種お知らせや特典に制限が生じることがあります。）",
      "4": "ランク基準は毎月1日午前11時から順次変更され、変更日から過去1年以内の累計実決済金額をもとに適用されます。",
      "6": "実決済金額は割引適用後、送料を除いた純粋な商品金額であり、注文日から7日経過後に加算されます。",
      "7": "割引コードは1回のご注文につき1つのみ使用でき、他の割引コードとの併用はできません。",
      "10": "一部の割引コードはメンバーシップ常時割引との重複適用ができない場合があります。",
      "11": "発行されたコードは使用と同時に消滅し、再発行および復元はできません。",
    },
  },
  login: {
    invalid_email: "有効なメールアドレスを入力してください。",
    in_app_browser_message:
      "現在使用中のブラウザではソーシャルログインを使用できません。<br/>メールログインまたは他のブラウザをご利用ください。",
    account_disable:
      "当該アカウントは退会申請を受け付けており、現在ログインおよびサービスのご利用は制限されています。<br/>会員アカウントおよび個人情報は、最終注文日から最短1日～最長30日経過後に自動的に削除されます。削除完了までは、同じメールアドレスでの再登録はできません。<br/>ストアをご利用される場合は、別のメールアドレスで新規会員登録のうえご利用ください。",
    min_password: "パスワードは5文字以上で入力してください。",
    social: "ソーシャル",
    kakao_continue: "Kakao で続ける",
    google_continue: "Google で続ける",
    social_continue: "ソーシャルログインで続ける",
    email_continue: "メールで続ける",
    reset_password: "パスワードの再設定",
    register: "会員登録",
    login: "ログイン",
    send_email: "メールを送信",
    connect: "アカウントと連携されています。",
    apply: "適用する",
    info: "メールアドレスとパスワードを設定して会員登録いただくと、お支払い、注文確認、配送状況の確認、ランク別特典など、より便利にストアをご利用いただけます。",
    personal_info: "プライバシーポリシーおよび利用規約に同意する（必須）",
    marketing_subscribe: "マーケティング情報の受信に同意する（任意）",
    auth: "本人確認を行う",
    auth_ask: "より安全なお取引のため、\n初回に1度、本人確認を行ってください。",
    verificaton_error: "認証に失敗しました。",
    social_login_reset_password:
      "メールでパスワード再設定用のリンクをお送りします。\n新しいパスワードに変更後、あらためてソーシャルログインをお試しください。",
    description:
      "{{storeName}} オンラインストアの会員になりませんか。<br /> 毎月のメンバーシップ特典に加え、お支払い、注文履歴の確認、配送状況の確認など、より便利にご利用いただけます。",
  },
  footer: {
    company1: "JKND株式会社",
    company2: "事業者登録番号 361-86-01005",
    company3: "代表 ジョナサン",
    company4: "ソウル特別市城東区アチャサン路159（聖水洞2街、JKND）",
    company5: "070-4048-5375",
    company6: "通信販売業申告 2024-ソウル城東-1504",
  },
  information: {
    email: "cs_jp@thisisneverthat.com",
    channel_talk: "thisisneverthat.channel.io",
    info1: "ストア利用中にお問い合わせがある場合は、以下の方法でお問い合わせください。",
    shipping: {
      method: "配送業者",
      method_description: "ヤマト運輸・佐川急便",
      zone: "送料",
      zone_description:
        "国内一律660円（税込)<br/>※沖縄•北海道及び離島、一部の地域は一律1,100円（税込<br/>※合計金額が15,400円（税込）以上で送料無料<br/>（沖縄•北海道及び離島、一部の地域対象外）",
      time: "",
      time_description: "",
      description: "※天候、交通事情、地域等の理由で商品の到着が遅れる場合がございます。ご了承下さい。",
      rate: "商品のお届け時期",
      rate_description: "注文確定後、５営業日以内に発送致します",
    },
  },
  return_reason: {
    select: "返品理由を選択",
    wrong_item: "商品の誤配送",
    defective: "商品の不良",
    size_large: "サイズが大きい",
    size_small: "サイズが小さい",
    unwanted: "自己都合",
    default: "その他",
  },
  loading: {
    payment: {
      title: "決済が進行中です。",
      description: "ページを更新したり閉じたりすると、<br/>進行中の決済がキャンセルされる場合があります。",
    },
  },
  deactivate_account: "退会が完了しました。",
  feedback: {
    title: "Feedback",
    description: "より良いストア体験のために、お客様のご意見をお聞かせください。",
    reward: "ご意見をお寄せいただいた方に10%割引コードをお贈りします。",
    leave: "ご意見を送る",
    form_title: "ストアのご利用体験をお聞かせください。",
    form_guide: "ご意見を残したい項目を選択し、内容をご入力ください。",
    form_multiple: "複数の項目を選択できます。",
    placeholder: "内容をご入力ください。",
    submit: "フィードバックを送信",
    thanks: "ありがとうございます",
    thanks_description: "いただいたご意見は、より良いストア体験のための参考にさせていただきます。",
    thanks_reward: "ご意見をお寄せいただいたお客様に、感謝の気持ちを込めて10%割引コードをお贈りします。",
    copy: "コピー",
    categories: {
      price: "商品の価格・品質",
      info: "商品のご案内",
      web: "ストア画面のご利用",
      delivery: "配送",
      discount: "割引特典",
      service: "カスタマーサービス",
      etc: "その他",
    },
  },
  toss_policy: {
    "1": "Toss 社員アカウントのご注文金額の上限は年間 ₩2,000,000 で、毎年1月1日にリセットされます。",
    "2": "累積注文金額とカート金額の合計が注文金額上限を超える場合、注文を進めることができません。カートの商品および金額を調整してご購入ください。",
    "3": "商品の割引率が Toss 社員割引の割引率を上回る場合は、商品の割引率のみが適用されます。",
    "4": "一部の商品は Toss 社員割引の対象外です。対象外の商品をご購入の場合も、累計注文金額には含まれます。",
    "5": "Toss社員アカウントは、Toss社員割引特典を除く別途の割引プロモーションが適用されません。",
    "6": "退職された場合、翌月1日にアカウントが無効化されます。無効化後はログインできないため、お問い合わせは右下のチャットをご利用ください。",
  },
  customer_error: {
    DEFAULT: "一時的なエラーが発生しました。しばらくしてからもう一度お試しください。",
    ALREADY_ENABLED: "このメールアドレスは既に登録されています。ログインしてください。",
    BAD_DOMAIN: "無効なメールアドレスです。正しいアドレスを入力してください。",
    BLANK: "必須項目です。入力してください。",
    CONTAINS_HTML_TAGS: "セキュリティのため、HTMLタグはご使用いただけません。",
    CONTAINS_URL: "URL（ウェブサイトのアドレス）を入力することはできません。",
    CUSTOMER_DISABLED: "このアカウントは一時的に無効化されています。カスタマーサポートまでお問い合わせください。",
    INVALID: "入力内容に誤りがあります。もう一度ご確認ください。",
    INVALID_MULTIPASS_REQUEST: "ログインセッションの有効期限が切れました。再度ログインをお試しください。",
    NOT_FOUND: "ご指定の住所が見つかりませんでした。再度ご確認ください。",
    PASSWORD_STARTS_OR_ENDS_WITH_WHITESPACE: "パスワードの最初と最後にスペース（空白）を含めることはできません。",
    TAKEN: "この情報は既に別のアカウントで使用されています。",
    TOKEN_INVALID: "認証トークンの有効期限が切れたか、無効です。もう一度やり直してください。",
    TOO_LONG: "入力文字数が多すぎます。もう少し短く入力してください。",
    TOO_SHORT: "入力文字数が足りません。もう少し長く入力してください。",
    UNIDENTIFIED_CUSTOMER: "メールアドレスまたはパスワードが一致しません。再度ご確認ください。",
    ADDRESS_ARGUMENT_EMPTY: "住所を入力してください。",
    ADDRESS_ID_DOES_NOT_EXIST: "ご指定の住所が見つかりませんでした。ページを再読み込みしてもう一度お試しください。",
    ADDRESS1_MISSING: "住所を入力してください。",
    COUNTRY_CODE_MISSING: "国を選択してください。",
    COUNTRY_NOT_EXIST: "選択された国はご利用いただけません。別の国をお選びください。",
    CUSTOMER_ADDRESS_ALREADY_EXISTS: "この住所は既に登録されています。",
    DELETING_CUSTOMER_DEFAULT_ADDRESS_NOT_ALLOWED: "デフォルトの住所は削除できません。先に別の住所をデフォルトに設定してください。",
    DEMOTING_CUSTOMER_DEFAULT_ADDRESS_NOT_ALLOWED: "デフォルトの住所は解除できません。別の住所をデフォルトに設定してください。",
    INVALID_FOR_COUNTRY: "住所の一部が選択された国と一致しません。郵便番号や都道府県をご確認ください。",
    INVALID_FOR_COUNTRY_AND_PROVINCE: "入力された郵便番号は、選択された都道府県（州）と一致しません。",
    INVALID_TERRITORY_CODE: "選択された国が正しくありません。別の国をお選びください。",
    PHONE_NUMBER_NOT_VALID: "電話番号を正しく入力してください。",
    REQUIRED: "必須項目を入力してください。",
    TERRITORY_CODE_MISSING: "国を選択してください。",
    ZONE_CODE_MISSING: "都道府県（州）を選択してください。",
  },
  cart_error: {
    DEFAULT: "一時的なエラーが発生しました。ページを再読み込みしてもう一度お試しください。",
    ADDRESS_FIELD_CONTAINS_EMOJIS: "住所に絵文字や特殊文字を入力することはできません。",
    ADDRESS_FIELD_CONTAINS_HTML_TAGS: "住所に入力できない文字が含まれています。",
    ADDRESS_FIELD_CONTAINS_URL: "住所にURL（ウェブサイトのアドレス）を入力することはできません。",
    ADDRESS_FIELD_DOES_NOT_MATCH_EXPECTED_PATTERN: "住所の形式が正しくありません。入力内容をもう一度ご確認ください。",
    ADDRESS_FIELD_IS_REQUIRED: "住所は必須項目です。入力してください。",
    ADDRESS_FIELD_IS_TOO_LONG: "住所が長すぎます。お手数ですが、短くまとめて入力してください。",
    BUNDLES_AND_ADDONS_CANNOT_BE_MIXED: "セット商品と追加オプション商品は同時にご購入いただけません。",
    BUYER_CANNOT_PURCHASE_FOR_COMPANY_LOCATION: "こちらの企業住所向けのご注文は承ることができません。",
    CART_TOO_LARGE: "カート内の商品数が上限を超えています。一部の商品を削除してください。",
    GIFT_CARD_RECIPIENT_INVALID: "ギフトカードの受取人情報が正しくありません。再度ご確認ください。",
    INVALID: "入力内容に誤りがあります。もう一度ご確認ください。",
    INVALID_COMPANY_LOCATION: "選択された企業の住所が確認できないか、ご利用いただけません。",
    INVALID_DELIVERY_ADDRESS_ID: "選択された配送先住所が見つかりませんでした。再度ご指定ください。",
    INVALID_DELIVERY_GROUP: "配送情報の設定中にエラーが発生しました。お手数ですがもう一度お試しください。",
    INVALID_DELIVERY_OPTION: "選択された配送方法はご利用いただけません。別の方法をお選びください。",
    INVALID_INCREMENT: "この商品は指定された販売単位でのみご購入いただけます。",
    INVALID_MERCHANDISE_LINE: "カート内の商品情報を読み込めませんでした。ページを更新してください。",
    INVALID_METAFIELDS: "商品の設定情報に問題が発生しました。カスタマーサポートまでご連絡ください。",
    INVALID_ZIP_CODE_FOR_COUNTRY: "入力された郵便番号は、選択された国と一致しません。",
    INVALID_ZIP_CODE_FOR_PROVINCE: "入力された郵便番号は、選択された都道府県（州）と一致しません。",
    LESS_THAN: "選択可能な最大数を超えています。数量を減らしてください。",
    MAXIMUM_EXCEEDED: "この商品はお一人様あたりの最大購入数量を超えています。",
    MERCHANDISE_LINE_TRANSFORMERS_RUN_ERROR: "カートの更新中にエラーが発生しました。しばらくしてからもう一度お試しください。",
    MERCHANDISE_NOT_APPLICABLE: "選択されたオプションでは、現在この商品をご購入いただけません。",
    MINIMUM_NOT_MET: "この商品は最低購入数量以上でご注文いただく必要があります。",
    MISSING_CUSTOMER_ACCESS_TOKEN: "企業の住所をご利用いただくには、ログインが必要です。",
    MISSING_DISCOUNT_CODE: "ディスカウントコードを入力してください。",
    MISSING_NOTE: "ご要望（メモ）を入力してください。",
    NOTE_TOO_LONG: "ご要望（メモ）が長すぎます。お手数ですが、短くまとめて入力してください。",
    ONLY_ONE_DELIVERY_ADDRESS_CAN_BE_SELECTED: "1回のご注文につき、選択できる配送先は1つのみです。",
    PARENT_LINE_INVALID_REFERENCE: "セット商品の追加に失敗しました。ページを再読み込みしてください。",
    PARENT_LINE_NESTING_TOO_DEEP: "セット商品の組み合わせが複雑すぎます。別のオプションをお選びください。",
    PARENT_LINE_NOT_FOUND: "セット商品の親アイテムが見つかりませんでした。",
    PARENT_LINE_OPERATION_BLOCKED: "組み合わせが正しくないため、カートに追加できませんでした。",
    PENDING_DELIVERY_GROUPS: "配送方法を読み込んでいます。少々お待ちください。",
    PROVINCE_NOT_FOUND: "選択された都道府県（州）の情報が見つかりませんでした。",
    SELLING_PLAN_NOT_APPLICABLE: "選択された定期便・購入プランは、現在この商品に適用できません。",
    SERVICE_UNAVAILABLE: "カートを保存できませんでした。お手数ですが、少し時間をおいて再度お試しください。",
    TOO_MANY_DELIVERY_ADDRESSES: "登録されている配送先住所が多すぎます。一部を削除してください。",
    UNSPECIFIED_ADDRESS_ERROR: "住所を確認できませんでした。入力内容を再度ご確認ください。",
    VALIDATION_CUSTOM: "入力された情報が正しくありません。再度ご確認ください。",
    VARIANT_REQUIRES_SELLING_PLAN: "この商品は定期便（サブスクリプション）でのみご購入いただけます。",
    ZIP_CODE_NOT_SUPPORTED: "入力された郵便番号は配送対象外の地域です。",
  },
};

export default jp;
